<template>
  <div>
    <br />
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <caption></caption>
                  <thead>
                    <tr>
                      <th
                        id="customer_id"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                        style="white-space: nowrap; width: 200px"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'customer_id'"
                        ></span>
                      </th>
                      <th
                        class="text-center align-middle"
                        id="empresa"
                        style="white-space: nowrap; width: 200px"
                      >
                        Empresa
                      </th>
                      <th
                        id="cnpj"
                        style="white-space: nowrap; width: 200px"
                        class="text-center align-middle"
                      >
                        CNPJ
                      </th>
                      <th
                        id="status"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Status
                      </th>
                      <th
                        id="plano"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Plano
                      </th>
                      <th
                        id="produto"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        &emsp; Produto &emsp;
                      </th>
                      <th
                        id="fatura_avulsa"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Fatura Avulsa
                      </th>
                      <th
                        id="cancelamento"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="contrato_id"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Contrato ID
                      </th>
                      <th
                        id="mes"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Mês
                      </th>
                      <th
                        id="fatura_id"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Fatura ID
                      </th>
                      <th
                        id="licencas"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Licenças
                      </th>
                      <th
                        id="contatos_receptivos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Contatos receptivos
                      </th>
                      <th
                        id="numeros"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Números
                      </th>
                      <th
                        id="ativos_unico"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos - único
                      </th>
                      <th
                        id="ativos_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos - campanha
                      </th>
                      <th
                        id="consultoria_mensal"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Consultoria Mensal
                      </th>
                      <th
                        id="plano_mensal"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Plano Mensal
                      </th>
                      <th
                        id="licencas_valor_minimo"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Licenças (valor mínimo)
                      </th>
                      <th
                        id="ativos_unico_valor_minimo"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos - único (valor mínimo)
                      </th>
                      <th
                        id="ativos_campanha_valor_minimo"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos - campanha (valor mínimo)
                      </th>
                      <th
                        id="protocolos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Protocolos
                      </th>
                      <th
                        id="auto_negociador"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Auto Negociador
                      </th>
                      <th
                        id="auto_negociador_valor_minimo"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Auto Negociador (valor mínimo)
                      </th>
                      <th
                        id="cross_sell_engajamento"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Cross Sell Engajamento
                      </th>
                      <th
                        id="setup_aquisicao"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Setup aquisição
                      </th>
                      <th
                        id="numero_extra"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Número extra
                      </th>
                      <th
                        id="consultoria"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Consultoria
                      </th>
                      <th
                        id="customizacao"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Customização
                      </th>
                      <th
                        id="suporte_24x7"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Suporte 24x7
                      </th>
                      <th
                        id="outros"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Outros
                      </th>
                      <th
                        id="atendimento"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Atendimento
                      </th>
                      <th
                        id="contato_agenda"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Contato/Agenda
                      </th>
                      <th
                        id="cpfs_unico"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        CPFs - Único
                      </th>
                      <th
                        id="cancelamento_sms"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="ativos_sms"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos - SMS
                      </th>
                      <th
                        id="contatos_envios_ativos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Contatos + Envios de Ativos
                      </th>
                      <th
                        id="ativos_unico_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos único + Ativos de Campanha
                      </th>
                      <th
                        id="relatorio"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Relatório
                      </th>
                      <th
                        id="mensagens"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Mensagens
                      </th>
                      <th
                        id="uam"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        UAM
                      </th>
                      <th
                        id="hsm"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        HSM
                      </th>
                      <th
                        id="hsm_ativos_unico"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        HSM - Ativos Único
                      </th>
                      <th
                        id="hsm_ativos_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        HSM - Ativos Campanha
                      </th>
                      <th
                        id="atendimento_protocolo"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Atendimento / Protocolo
                      </th>
                      <th
                        id="ativos_campanha_sms"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos Campanha - SMS
                      </th>
                      <th
                        id="sessao_autenticacao"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Autenticação
                      </th>
                      <th
                        id="sessao_utilitario"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Utilitário
                      </th>
                      <th
                        id="sessao_marketing"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Marketing
                      </th>
                      <th
                        id="sessao_servicos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Serviços
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Números Whatsapp Enterprise
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputNumberFilter: !data || data.length == 0,
                          }"
                          v-model="filters.customer_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectPlanTypes
                          :selected="filters.plan_type_id"
                          @change="setFilter('plan_type_id', $event)"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          :productsNotAppear="[2, 3, 4, 5, 6]"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.detached"
                          @change="setFilter('detached', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ invoice.customer_id }}
                      </td>
                      <td
                        class="text-left align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.co_name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.customer
                            ? invoice.customer.documents.value
                            : null | cnpj | cpf
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ getStatus(invoice.status) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.plan_type
                            ? invoice.plan_type
                            : invoice.plan_description
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.product.name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.detached }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.cancellation ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contr_id }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.billing_month | date }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.id }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [1]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [2]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [3]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [4]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [5]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [6]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [7, 20, 22, 32]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [8]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [9]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [10]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [11]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [12]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [13]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [14, 26, 37]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [41, 42, 43]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [15]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [16]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [17]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [18]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [19, 21]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [23]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [24]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [25]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [27]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [28]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [29]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [56]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [69]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [55]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [30]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [31]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [33]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [34]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [35]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [36]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [54, 66]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [53, 65]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [52, 64]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [51, 63]) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [44, 68]) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                      >
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 2"
                        >{{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                        >{{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                        >{{ data.current_page + 1 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 2"
                        >{{ data.current_page + 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                      >
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.last_page"
                      >
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectProducts from '@/components/forms/SelectProducts';
import SelectStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectYesNo from '@/components/forms/SelectYesNo';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectContractStatus from '@/components/forms/SelectContractStatus';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportInvoiceAnalyticConsumptions',
  props: ['start', 'finish', 'createdAt'],
  components: {
    SelectProducts,
    SelectContractStatus,
    SelectStatuses,
    SelectPlanTypes,
    SelectYesNo,
  },
  data() {
    return {
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      sortType: localStorage.reportInvoicesAnalyticsSortType
        ? localStorage.reportInvoicesAnalyticsSortType
        : 'id',
      sortReverse: localStorage.reportInvoicesAnalyticsSortReverse
        ? JSON.parse(localStorage.reportInvoicesAnalyticsSortReverse)
        : false,
      amount: localStorage.reportInvoicesAnalyticsDataAmount
        ? localStorage.reportInvoicesAnalyticsDataAmount
        : 100,
      page: localStorage.reportInvoicesAnalyticsDataPage
        ? localStorage.reportInvoicesAnalyticsDataPage
        : 1,
      filters: {
        id: localStorage.reportInvoicesAnalyticsFilterId
          ? localStorage.reportInvoicesAnalyticsFilterId
          : '',
        customer_id: localStorage.reportInvoicesAnalyticsFilterCustomer
          ? localStorage.reportInvoicesAnalyticsFilterCustomer
          : '',
        name: localStorage.reportInvoicesAnalyticsFilterName
          ? localStorage.reportInvoicesAnalyticsFilterName
          : '',
        cnpj: localStorage.reportInvoicesAnalyticsFilterCnpj
          ? localStorage.reportInvoicesAnalyticsFilterCnpj
          : '',
        product: localStorage.reportInvoicesAnalyticsFilterProduct
          ? localStorage.reportInvoicesAnalyticsFilterProduct
          : '',
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    async download() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando relatório',
        reason: '',
      };

      const urlCount = `${baseApiUrl}/v1/report/invoice/analytics/quantity/count${this.convertFilters()}`;
      const total = await axios.get(urlCount);

      if (total.data <= 1000) {
        const url = `${baseApiUrl}/v1/report/invoice/analytics/quantity/download${this.convertFilters()}`;
        axios
          .get(url)
          .then((res) => {
            const arrData = res.data;
            let csvContent = 'data:text/csv;charset=utf-8,';
            let array = this.mountArray(arrData);
            csvContent += array.join('\n').replace(/(^\[)|(\]$)/gm, '');

            const data = encodeURI(csvContent);

            const link = document.createElement('a');
            link.setAttribute('href', data);

            let fileName = `relatorio_analitico_faturamento`;

            this.clearAlert();
            if (this.start) {
              fileName += `_${this.start}`;
            }
            fileName = `${fileName}.csv`;
            link.setAttribute('download', fileName);

            link.click();
          })
          .catch((error) => {
            this.logMessageFailed(error.response);
          });
      } else {
        let arrData = [];
        let pages = Math.ceil(total.data / 1000);
        for (let index = 1; index <= pages; index++) {
          let data = await this.getDataByPages(index);
          arrData = arrData.concat(data);
        }
        let csvContent = 'data:text/csv;charset=utf-8,';
        let array = this.mountArray(arrData);
        csvContent += array.join('\n').replace(/(^\[)|(\]$)/gm, '');

        const data = encodeURI(csvContent);

        const link = document.createElement('a');
        link.setAttribute('href', data);

        let fileName = `relatorio_analitico_faturamento`;

        this.clearAlert();
        if (this.start) {
          fileName += `_${this.start}`;
        }
        fileName = `${fileName}.csv`;
        link.setAttribute('download', fileName);

        link.click();
      }
    },

    getDataByPages(index) {
      const url = `${baseApiUrl}/v1/report/invoice/analytics/quantity/page/${index}/download${this.convertFilters()}`;
      return axios
        .get(url)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.customer_id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.status = '';
      this.filters.product = '';
      this.filters.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.filters.plan_type_id = '';
      this.filter.detached = '';
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('reportInvoicesAnalyticsFilterId', this.filters.id);
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCustomer',
        this.filters.customer_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterName',
        this.filters.name
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCnpj',
        this.filters.cnpj
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterStatus',
        this.filters.status
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterProduct',
        this.filters.product
      );
      localStorage.setItem('reportInvoicesAnalyticsDataAmount', this.amount);
      localStorage.setItem('reportInvoicesAnalyticsDataPage', this.page);
      localStorage.setItem('reportInvoicesAnalyticsSortType', this.sortType);
      localStorage.setItem(
        'reportInvoicesAnalyticsSortReverse',
        this.sortReverse
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterId',
        this.filters.plan_type_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterDetached',
        this.filters.detached
      );
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&customer=${this.filters.customer_id ? this.filters.customer_id : ''}
        &name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&product=${
        this.filters.product ? this.filters.product : ''
      }&planType=${
        this.filters.plan_type_id ? this.filters.plan_type_id : ''
      }&amount=${this.amount}&detached=${
        this.filters.detached ? this.filters.detached : ''
      }&sortType=${this.sortType}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &start=${this.start}
      &end=${this.finish ? this.finish : this.start}&createdAt=${
        this.createdAt
      }`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/report/invoice/analytics/quantity${this.convertFilters()}`;
      axios(url)
        .then((res) => {
          this.data = res.data;
          this.$emit('updateLoading');
          if (res.data.current_page > res.data.last_page) {
            this.page = 1;
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sumDetail(details, ids) {
      return details
        .filter((item) => ids.includes(item.detail_id))
        .map((item) => parseFloat(item.amount))
        .reduce((prev, curr) => prev + curr, 0);
    },
    mountArray(arrayInvoices) {
      let linesArray = [];
      linesArray[0] =
        'ID Cliente;Empresa;CNPJ;Status;Plano;Produto;Fatura Avulsa;Cancelamento;Contrato ID;Mês;Fatura ID;Total Fatura;Desconto;Acréscimo;Total Cobrado;Licenças;Contatos receptivos;Números;Ativos - único;Ativos - campanha;Consultoria mensal;' +
        'Plano Mensal;Licenças (valor mínimo);Ativos - único (valor mínimo);Ativos - campanha (valor mínimo);Protocolos;Auto Negociador;Auto Negociador (valor mínimo);Cross Sell Engajamento;Setup aquisição;Número extra;' +
        'Consultoria;Customização;Suporte 24x7;Outros;Atendimento;Contato/Agenda;CPFs - Único;Cancelamento;Ativos - SMS;Contatos + Envios de Ativos;Ativos único + Ativos de Campanha;Relatório;Mensagens;UAM;HSM;HSM - Ativos Único;HSM - Ativos Campanha;' +
        'Atendimento / Protocolo;Ativos Campanha - SMS;Sessão - Autenticação;Sessão - Utilitário;Sessão - Marketing;Sessão - Serviços;Números Whatsapp Enterprise';

      arrayInvoices.forEach((item) => {
        const line =
          item.customer_id +
          ';' +
          (item.co_name || '') +
          ';' +
          item.customer.documents.value +
          ';' +
          this.getStatus(item.status) +
          ';' +
          (item.plan_type
            ? item.plan_type
            : item.plan_description
            ? item.plan_description
            : '') +
          ';' +
          item.product.name +
          ';' +
          item.detached +
          ';' +
          (item.cancellation ? 'Sim' : 'Não') +
          ';' +
          (item.contr_id || '') +
          ';' +
          item.billing_month +
          ';' +
          item.id +
          ';' +
          this.formatCurrency(item.price_total) +
          ';' +
          this.formatCurrency(item.discount) +
          ';' +
          this.formatCurrency(item.price_extra) +
          ';' +
          this.formatCurrency(item.price_total - item.discount) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [1])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [2])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [3])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [4])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [5])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [6])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [7, 20, 22, 32])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [8])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [9])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [10])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [11])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [12])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [13])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [14, 26, 37])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [41, 42, 43])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [15])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [16])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [17])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [18])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [19, 21])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [23])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [24])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [25])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [27])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [28])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [29])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [56])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [69])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [55])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [30])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [31])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [33])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [34])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [35])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [36])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [54, 66])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [53, 65])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [52, 64])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [51, 63])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [44, 68])) +
          ';';
        linesArray.push(line);
      });
      return linesArray;
    },
    formatCurrency(value) {
      if (!value) {
        value = 0;
      }
      return value.toLocaleString();
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return 'Não Conferida';
        case 1:
          return 'Conferida';
        case 2:
          return 'Venda Gerada';
        case 3:
          return 'Cancelada';
        case 4:
          return 'Paga';
        case 5:
          return 'Parcialmente Paga';
        case 6:
          return 'Expirado';
        default:
          break;
      }
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
    this.clearAlert();
  },
};
</script>

<style scoped>
.inputNumberFilter {
  width: 100px;
}

.inputTextFilter {
  width: 200px;
}
</style>
